import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { User } from '../api/types';
import config from '../config';

async function getUser(axios: AxiosInstance): Promise<User> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/user`);

  return data;
}

export default function useUserQuery() {
  const axios = useAxios();
  const toast = useToast();
  const navigate = useNavigate();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getUser(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      const error = query.error as any;
      if (error?.response?.status !== 503) {
        manageErrorResponse(toast, error);
      }
      if (error?.response?.status >= 500 && error?.response?.status !== 503) {
        navigate('/app/errorPage', { replace: true });
      }
    }
  }, [navigate, query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['User'] as const satisfies QueryKey;
}
useUserQuery.getKey = getKey;
